/* tslint:disable */
/* eslint-disable */

/**
 * Service type
 */
export enum ServiceType {
  DineIn = 'DineIn',
  BringToTable = 'BringToTable',
  Pickup = 'Pickup',
  DriveThru = 'DriveThru',
  Curbside = 'Curbside',
  DeliveryByChannel = 'DeliveryByChannel',
  DeliveryByRestaurant = 'DeliveryByRestaurant'
}
